export default "__VITE_ASSET__DlAMV9fU__"